import { ChartElement } from '@modules/reports/models/chart-element';
import { ReferralReportsItem } from '@modules/reports/models/referral-reports-item';
import { createAction, props } from '@ngrx/store';
import { AveragesPerJob } from '@shared/models/averages-per-job';
import { AvgResponseTime } from '@shared/models/avg-response-time';
import { Pagination } from '@shared/pagination';
import { Job, AggregatedJobData } from '@shared';
import { DashboardReportModel } from '@shared/models/dashboard-reports';
import { ReferralCountByStage } from '../models/referral-count-by-stage';
import { ReferralReportsFilters } from '../models/referral-reports-filters';

export const loadJobFunctions = createAction(
  '[Referral Reports Page] Load Job Functions',
  props<{ filters: ReferralReportsFilters; functionsPage: string }>(),
);

export const loadJobFunctionsSuccess = createAction(
  '[Referral Reports Page] Load Job Functions Success',
  props<{ jobFunctions: string[] }>(),
);

export const loadJobFunctionsFail = createAction(
  '[Referral Reports Page] Load Job Functions Fail',
  props<{ error: any }>(),
);

export const loadJobDepartments = createAction(
  '[Referral Reports Page] Load Job Departments',
  props<{ filters: ReferralReportsFilters; departmentsPage: string }>(),
);

export const loadJobDepartmentsSuccess = createAction(
  '[Referral Reports Page] Load Job Departments Success',
  props<{ jobDepartments: string[] }>(),
);

export const loadJobDepartmentsFail = createAction(
  '[Referral Reports Page] Load Job Departments Fail',
  props<{ error: any }>(),
);

export const referralReportsPageLoad = createAction(
  '[Referral Reports Page] Get',
  props<{ filters: ReferralReportsFilters }>(),
);
export const referralReportsPageLoadSuccess = createAction(
  '[Referral Reports Page] Get Success',
  props<{ payload: Pagination<ReferralReportsItem> }>(),
);
export const referralReportsPageLoadFail = createAction(
  '[Referral Reports Page] Get Fail',
  props<{ error: any }>(),
);

export const loadReferralsByJobFunction = createAction(
  '[Referral Reports Page] Load Referrals By Job Function',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadReferralsByJobFunctionSuccess = createAction(
  '[Referral Reports Page] Load Referrals By Job Function Success',
  props<{ elements: ChartElement[] }>(),
);

export const loadReferralsByJobFunctionFail = createAction(
  '[Referral Reports Page] Load Referrals By Job Function Fail',
  props<{ error: any }>(),
);

export const loadReferralsByReferralFunction = createAction(
  '[Referral Reports Page] Load Referrals By Referral Function',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadReferralsByReferralFunctionSuccess = createAction(
  '[Referral Reports Page] Load Referrals By Referral Function Success',
  props<{ elements: ChartElement[] }>(),
);

export const loadReferralsByReferralFunctionFail = createAction(
  '[Referral Reports Page] Load Referrals By Referral Function Fail',
  props<{ error: any }>(),
);

export const loadOldestReferralDate = createAction(
  '[Referral Reports Page] Load Oldest Referral Date',
);

export const loadOldestReferralDateSuccess = createAction(
  '[Referral Reports Page] Load Oldest Referral Date Success',
  props<{ referralOldestDate: Date }>(),
);

export const loadOldestReferralDateFail = createAction(
  '[Referral Reports Page] Load Oldest Referral Date Fail',
  props<{ error: any }>(),
);

export const loadReferralsByJobDepartment = createAction(
  '[Referral Reports Page] Load Referrals By Job Department',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadReferralsByJobDepartmentSuccess = createAction(
  '[Referral Reports Page] Load Referrals By Job Department Success',
  props<{ elements: ChartElement[] }>(),
);

export const loadReferralsByJobDepartmentFail = createAction(
  '[Referral Reports Page] Load Referrals By Job Department Fail',
  props<{ error: any }>(),
);

export const loadReferralsByReferralDepartment = createAction(
  '[Referral Reports Page] Load Referrals By Referral Department',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadReferralsByReferralDepartmentSuccess = createAction(
  '[Referral Reports Page] Load Referrals By Referral Department Success',
  props<{ elements: ChartElement[] }>(),
);

export const loadReferralsByReferralDepartmentFail = createAction(
  '[Referral Reports Page] Load Referrals By Referral Department Fail',
  props<{ error: any }>(),
);

export const loadReferralCountByStage = createAction(
  '[Referral Reports Page] Load Referral Count By Stage',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadReferralCountByStageSuccess = createAction(
  '[Referral Reports Page] Load Referral Count By Stage Success',
  props<{ counts: ReferralCountByStage[] }>(),
);

export const loadReferralCountByStageFail = createAction(
  '[Referral Reports Page] Load Referral Count By Stage Fail',
  props<{ error: any }>(),
);

export const loadAllJobsByParams = createAction(
  '[Reports Page] Load All Jobs By Params',
  props<{ params: any }>(),
);

export const loadAllJobsByParamsSuccess = createAction(
  '[Reports Page] Load All Jobs By Params Success',
  props<{ response: Pagination<Job> }>(),
);

export const loadAllJobsByParamsError = createAction(
  '[Reports Page] Load All Jobs By Params Error',
  props<{ error: any }>(),
);

export const loadAggregatedTotalDirectPerPhasesData = createAction(
  '[Reports Page] Load Aggregated Total Direct Per Phase Data',
  props<{ jobsIds: number[] }>(),
);

export const loadAggregatedTotalDirectPerPhasesDataSuccess = createAction(
  '[Reports Page] Load Aggregated Total Direct Per Phase Data Success',
  props<{ allActiveJobsTotalDirectPerPhaseList: [] }>(),
);

export const loadAvgResponseTime = createAction(
  '[Referral Reports Page] Load Average Response Time',
  props<{ jobIds: number[] }>(),
);

export const loadAvgResponseTimeSuccess = createAction(
  '[Referral Reports Page] Load Average Response Time Success',
  props<{ response: AvgResponseTime[] }>(),
);

export const loadAvgResponseTimeFail = createAction(
  '[Referral Reports Page] Load Average Response Time Fail',
  props<{ error: any }>(),
);

export const loadDashboardReports = createAction(
  '[Referral Reports Dashboard Page] Load Dashboard Reports Applicants',
  props<{ filters?: ReferralReportsFilters }>(),
);

export const loadDashboardReportsSuccess = createAction(
  '[Referral Reports Dashboard Page] Loaded Dashboard Reports Applicants',
  props<{ response: DashboardReportModel }>(),
);

export const loadDashboardReportsFail = createAction(
  '[Referral Reports Dashboard Page] Load fail Dashboard Reports Applicants',
  props<{ error: any }>(),
);

export const loadDashboardReportsSubmissions = createAction(
  '[Referral Reports Dashboard Page] Load Dashboard Reports Applicants Submmissions',
  props<{ filters?: ReferralReportsFilters }>(),
);

export const loadDashboardReportsSuccessSubmissions = createAction(
  '[Referral Reports Dashboard Page] Loaded Dashboard Reports Applicants Submmissions',
  props<{ response: DashboardReportModel }>(),
);

export const loadDashboardReportsFailSubmissions = createAction(
  '[Referral Reports Dashboard Page] Load fail Dashboard Reports Applicants Submmissions',
  props<{ error: any }>(),
);

export const loadDashboardReportsOffer = createAction(
  '[Referral Reports Dashboard Page] Load Dashboard Reports Applicants Offer',
  props<{ filters?: ReferralReportsFilters }>(),
);

export const loadDashboardReportsSuccessOffer = createAction(
  '[Referral Reports Dashboard Page] Loaded Dashboard Reports Applicants Offer',
  props<{ response: DashboardReportModel }>(),
);

export const loadDashboardReportsFailOffer = createAction(
  '[Referral Reports Dashboard Page] Load fail Dashboard Reports Applicants Offer',
  props<{ error: any }>(),
);

export const loadAveragesPerJob = createAction(
  '[Dashboard Page] Load Averages Per Job',
  props<{ params?: ReferralReportsFilters }>(),
);

export const loadAveragesPerJobSuccess = createAction(
  '[Dashboard Page] Load Averages Per Job Success',
  props<{ averagesPerJob: AveragesPerJob }>(),
);

export const loadAveragesPerJobFail = createAction(
  '[Dashboard Page] Load Averages Per Job Fail',
  props<{ error: any }>(),
);

export const sendEmailReferralReport = createAction(
  '[Referral Report Page] send email',
  props<{
    params?: ReferralReportsFilters;
  }>(),
);

export const sendEmailSuccessReport = createAction('[Referral Report Page] email sent');

export const sendEmailFailReport = createAction(
  '[Referral Report Page] fail email sent',
  props<{ error: any }>(),
);

export const changeStateReferralReport = createAction(
  '[Referral Report Page] change status flag]',
  props<{ flag: boolean }>(),
);
